import { intersection } from 'lodash';

import {
  CRITICAL_POIS_CATEGORIES,
  EDIT_SUGGESTION_LABELS,
} from '../constants/constants';

/**
 * @param payload payload of editSuggestion prepared to be sent to API
 * @param item current selected active item in UI
 */
export const enhanceEditSuggestoinPayload = (payload, item) => {
  const isCriticalPOIAffected =
    intersection(CRITICAL_POIS_CATEGORIES, item?.properties?.poi_category)
      .length > 0;

  if (isCriticalPOIAffected) {
    if (!payload.labels) payload.labels = [];

    if (!payload.labels.includes(EDIT_SUGGESTION_LABELS.critical_poi)) {
      payload.labels.push(EDIT_SUGGESTION_LABELS.critical_poi);
    }
  }
};

export const getReferrer = () => {
  const urlSearchParams = new URLSearchParams(window.location.href);
  const utmCampaign = urlSearchParams.get('utm_campaign');
  if (utmCampaign !== 'referrer') return null;
  return urlSearchParams.get('utm_source');
};

export const getUrlSearchParams = (): URLSearchParams => {
  const hash = window.location.hash;
  const queryIndex = hash.indexOf('?');
  const queryString = queryIndex !== -1 ? hash.substring(queryIndex + 1) : '';
  return new URLSearchParams(queryString);
};

export const getReferrerAccount = (): string | undefined => {
  const params = getUrlSearchParams();

  const referrerAccount = params.get('referrer_account');
  if (referrerAccount) {
    return referrerAccount;
  }
  const accessToken = params.get('access_token');
  if (accessToken) {
    try {
      const parts = accessToken.split('.');
      if (parts.length !== 3) {
        throw new Error('Malformed mapbox access token');
      }
      const payload = parts[1];
      const decoded = atob(payload);
      const obj = JSON.parse(decoded);
      const uValue = obj.u;
      return `${uValue}`;
    } catch (error) {
      return;
    }
  }
  return;
};
